import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ToastType = 'info' | 'success' | 'error' | 'warning' | 'neutral';
export type ToastPosition = 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-right';

export type ToastPayload = {
  type: ToastType;
  position: ToastPosition;
  titleText: string;
  description?: string;
  dismissible?: boolean;
  autoDismissDuration?: number;
};

export type ToastState = {
  activeToast: ToastPayload | null;
};

export const initialToastState: ToastState = {
  activeToast: null,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState: initialToastState,
  reducers: {
    showToast(state, action: PayloadAction<ToastPayload>) {
      state.activeToast = action.payload;
    },
    hideToast(state) {
      state.activeToast = null;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;

export const selectActiveToast = (state: { toast: ToastState }) => state.toast.activeToast;
